import * as React from 'react';
import './TopbarComponent.css';

import {t} from 'react-multi-lang';
import {NavLink} from "react-router-dom";

import {IMainProps} from "../../containers/MainContainer";
import IRoute from "../../interfaces/IRoute";
import routeList from '../../routes';

class TopbarComponent extends React.PureComponent<IMainProps> {
    public render() {
        const routes = routeList()
            .filter((route: IRoute) => route.display)
            .map((route: IRoute) =>
                <NavLink key={route.name} to={route.url} className="w_sidebar_icon"
                         activeClassName="w_sidebar_icon_active">
                    {route.name}
                </NavLink>);

        return (
            <nav className="w_navbar navbar navbar-expand-md d-md-none navbar-dark">
                <div className="navbar-brand">{t('login.login')}</div>
                <div className="navbar-nav w_project_name">{t('login.project_name')} {this.props.instanceID}</div>
                <button className="navbar-toggler" type="button" data-toggle="collapse"
                        data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false"
                        aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"/>
                </button>
                <div className="collapse navbar-collapse" id="navbarToggler">
                    <div className="navbar-nav mr-auto mt-2 mt-lg-0">
                        {routes}
                    </div>
                </div>
            </nav>
        );
    }
}

export default TopbarComponent;


// WEBPACK FOOTER //
// ./src/components/TopbarComponent/TopbarComponent.tsx